import { Card, Container } from 'reactstrap';

import FormLoader from './parts/FormLoader';
import StudentFile from './parts/StudentFile';
import StudentFileFilterLoader from './parts/StudentFileListLoader';

export default function index() {
  return (
    <Container fluid>
      <Card className="p-4 mt-2">
        <FormLoader>
          <StudentFileFilterLoader>
            <StudentFile />
          </StudentFileFilterLoader>
        </FormLoader>
      </Card>
    </Container>
  );
}
